__webpack_require__.p = "/aims-presentation/";